import { render } from "./СallToAction.vue?vue&type=template&id=74c3a0a2"
import script from "./СallToAction.vue?vue&type=script&lang=js"
export * from "./СallToAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__